<script lang="ts" setup>
import { useUserStoreRef } from '@/stores';
import { getColorByString, type ObjectColor } from '@/utilities';
import { computed } from 'vue';

const { user } = useUserStoreRef();

const initials = computed(() => {
    const parts = user.value?.Name?.split(' ').map((p: string) => p.substring(0, 1).toUpperCase());
    if (!parts) {
        return '  ';
    }
    if (parts?.length == 1) {
        return parts[0] + ' ';
    } else return parts[0] + parts[parts?.length - 1];
});

const colors = computed<ObjectColor>(() => {
    let text = '';
    if (user.value?.Name != null) {
        text = user.value?.Name;
    } else if (user.value?.Email != null) {
        text = user.value?.Email;
    } else if (user.value?.ID != null) {
        text = user.value?.ID.toString();
    }

    return getColorByString(text, 'light');
});
</script>
<template>
    <div v-if="user?.GoogleAvatar != null && user.GoogleAvatar != ''">
        <img
            :src="user?.GoogleAvatar"
            alt="avatar"
            class="avatar"
        />
    </div>
    <div
        v-else
        class="avatar"
        :style="{ background: colors.background, color: colors.foreground, 'box-shadow': `0px 0px 2px 2px ${colors.border}` }"
    >
        <span class="opacity-50">{{ initials }}</span>
    </div>
</template>
<style scoped>
.avatar {
    width: 30px;
    height: 30px;
    border-radius: 50% !important;
}
div.avatar {
    padding: 0.3em;
    font-weight: bold;
}
</style>
